import { useEffect, useState } from 'react'

/**
 * Debounce a rapidly-changing value (typing in a search box, etc.).
 * Used by AF-124 BankPicker (200ms) and the queue filter inputs.
 */
export function useDebounce<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(id)
  }, [value, delayMs])
  return debounced
}
